import { useCallback, useMemo } from "react";
import { usePostRequest } from "../ApiWrappers/usePostRequest"
import { Config } from "src/Utils/ConfigService/LoadConfig";
import { logger } from "src/Utils/LoggerService/LoggerService";

export enum LicenseType{
    AuraAppLicenses = 0,
    CloudStorageLicenses = 1
}

interface ILicenseManagement{
    licenseType:LicenseType,
    entitlementId:string
}

interface IAssignLicense{
    entitlementId:string
}

export const useDistributorLicenseService = () => {
    const baseUrl = useMemo(() => Config.GetConfigData().auraLicensingService.serviceUrl,[]);
    const {postRequest, reqestError, reqestLoading, reqestResponse} = usePostRequest();

    const assignLicenseToClinic = useCallback((entitlementId: string, clinicId:string, distributorId: string) => {
        const requestUrl = `${baseUrl}api/v1/license/clinic/${clinicId}/assign/${distributorId}`;
        logger.logInformation(`Request to assign license for entitlement id ${entitlementId} to clinic ${clinicId} was made`)
        let req:IAssignLicense = {
            entitlementId: entitlementId
        }
        postRequest<IAssignLicense>(req,requestUrl)
    },[baseUrl, postRequest]) 

    const unassignLicenseFromPartner = useCallback((licenseType:LicenseType, entitlementId: string, clinicId:string, distributorId: string) => {
        const requestUrl = `${baseUrl}api/v1/license/clinic/${clinicId}/unassign/${distributorId}`;
        logger.logInformation(`Request to unassign license for entitlement id ${entitlementId} to clinic ${clinicId} was made`)
        let req:ILicenseManagement = {
            licenseType:licenseType,
            entitlementId: entitlementId
        }
        postRequest<ILicenseManagement>(req,requestUrl)
    },[baseUrl, postRequest])

    return { assignLicenseToClinic, unassignLicenseFromPartner, reqestResponse, reqestLoading, reqestError };
}